import { Col, Row } from "reactstrap";
import { Fragment, useEffect, useState } from "react";
import { DEFAULT_PER_PAGE } from "_constants";
import { useQuery } from "@apollo/client";
import { GET_TRANSACTIONS } from "_queries/Admin";
import { transactionsFilter } from "_utils";
import { Filters } from "./Filters";
import { Actions } from "./Actions";
import { Listing } from "./Listing";
import { StatWidgets } from "_components";
import { TRANSACTIONS_STATS } from "_queries/Admin";
import { useSearchParams } from "react-router-dom";

const blockWidgets = [
  {
    id: 1,
    label: "Orders",
    icon: "ri-numbers-fill",
    decimals: "",
    prefix: "",
    key: "totalSales",
  },
  {
    id: 2,
    label: "Tentative Commission",
    icon: "ri-award-fill",
    decimals: 2,
    prefix: "$",
    key: "totalCommission",
  },
  {
    id: 3,
    label: "Tentative Payable",
    icon: "ri-medal-fill",
    decimals: 2,
    prefix: "$",
    key: "totalPayable",
  },
  {
    id: 4,
    label: "Tentative Profit",
    icon: "ri-medal-2-fill",
    decimals: 2,
    prefix: "$",
    key: "totalProfit",
  },
];

export const Transactions = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(DEFAULT_PER_PAGE);
  const [filters, setFilters] = useState(null);
  const [selectedTransactions, setSelectedTransactions] = useState([]);
  const [searchParams] = useSearchParams();
  const invoice_no = searchParams.get("invoice_no");

  useEffect(() => {
    handleFilterChange("invoice_no", invoice_no);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoice_no]);

  const { data, loading, refetch } = useQuery(GET_TRANSACTIONS, {
    variables: transactionsFilter(currentPage, perPage, filters),
  });

  const { data: dataTranStats, loading: loadingTranStats } = useQuery(
    TRANSACTIONS_STATS,
    {
      variables: transactionsFilter(null, null, filters),
      fetchPolicy: "no-cache",
    }
  );

  const paginatedData = data?.transactionsAdmin?.transactions;
  const numberOfTotalPages = data?.transactionsAdmin.count;
  const dataWidgets = dataTranStats?.transactionsAdminStats;

  const handleFilterChange = (key, value) => {
    setFilters(() => {
      return {
        ...filters,
        [key]: value,
      };
    });
  };

  const handleTransactionSelect = (transactionsArray) => {
    const updatedTransactions = [...selectedTransactions];
    transactionsArray.forEach((item) => {
      const index = updatedTransactions.findIndex(
        (transaction) => transaction === item.isCheckedValue
      );

      // If the item is checked, add it to updatedTransactions
      if (item.isChecked && index === -1) {
        updatedTransactions.push(item.isCheckedValue);
      }

      // If the item is unchecked, remove it from updatedTransactions
      if (!item.isChecked && index !== -1) {
        updatedTransactions.splice(index, 1);
      }
    });

    setSelectedTransactions(updatedTransactions);
  };

  const statsProps = {
    data: dataWidgets,
    loading: loadingTranStats,
    blocks: blockWidgets,
  };
  const filtersProps = {
    setCurrentPage,
    handleFilterChange,
    filters,
  };
  const actionsProps = {
    selectedTransactions,
    setSelectedTransactions,
    refetch,
  };
  const listingProps = {
    numberOfTotalPages,
    paginatedData,
    setCurrentPage,
    setPerPage,
    currentPage,
    perPage,
    loading,
    handleTransactionSelect,
    selectedTransactions,
  };

  return (
    <Fragment>
      <Row id="stats">
        <StatWidgets {...statsProps} />
      </Row>
      <Row id="filter">
        <Col lg={12}>
          <Filters {...filtersProps} />
        </Col>
      </Row>
      <Row id="action">
        <Col lg={12}>
          <Actions {...actionsProps} />
        </Col>
      </Row>
      <Row id="listing">
        <Col lg={12}>
          <Listing {...listingProps} />
        </Col>
      </Row>
    </Fragment>
  );
};
